import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "row schedule-therapy-dates-box" }
const _hoisted_2 = { class: "col-sm-6" }
const _hoisted_3 = { class: "recent-activity-box" }
const _hoisted_4 = { class: "list ps-0 mb-0 list-unstyled" }
const _hoisted_5 = { class: "position-relative fw-medium text-dark-emphasis pt-10 pe-0 ps-50" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "icon position-absolute start-0 rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-play" })
], -1 /* HOISTED */)
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_9 = ["min"]
const _hoisted_10 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_11 = { class: "col-sm-6" }
const _hoisted_12 = { class: "recent-activity-box" }
const _hoisted_13 = { class: "list ps-0 mb-0 list-unstyled" }
const _hoisted_14 = { class: "icon position-absolute start-0 rounded-circle text-center" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_17 = ["min"]
const _hoisted_18 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_19 = { class: "small text-danger lh-1 m-0 mt-1" }
const _hoisted_20 = {
  key: 1,
  class: "form-messages mt-2 px-1"
}
const _hoisted_21 = {
  key: 0,
  class: "row"
}
const _hoisted_22 = { class: "col-12" }
const _hoisted_23 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_24 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_25 = { class: "d-flex gap-3 flex-wrap" }
const _hoisted_26 = { class: "d-flex" }
const _hoisted_27 = ["value"]
const _hoisted_28 = ["label"]
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "d-flex align-items-end justify-content-end gap-5" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = {
  key: 1,
  class: "table-responsive mb-3"
}
const _hoisted_33 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_34 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_35 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_36 = {
  key: 0,
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_37 = {
  key: 1,
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
}
const _hoisted_38 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_39 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_40 = ["onUpdate:modelValue"]
const _hoisted_41 = ["value"]
const _hoisted_42 = { key: 1 }
const _hoisted_43 = {
  key: 0,
  class: "shadow-none lh-1 fw-medium text-black-emphasis"
}
const _hoisted_44 = { class: "form-check form-switch d-inline-block" }
const _hoisted_45 = ["onUpdate:modelValue"]
const _hoisted_46 = {
  key: 1,
  class: "shadow-none lh-1 fw-medium text-body-tertiary text-end"
}
const _hoisted_47 = ["onClick"]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("i", { class: "ph-bold ph-x" }, null, -1 /* HOISTED */)
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = { class: "d-flex align-items-end justify-content-end flex-1 ms-auto gap-3" }
const _hoisted_51 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!

  return (_ctx.loading)
    ? (_openBlock(), _createBlock(_component_SpinnerLoading, {
        key: 0,
        class: "mt-50"
      }))
    : (_openBlock(), _createElementBlock("form", {
        key: 1,
        onSubmit: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createCommentVNode(" DATE RANGE "),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("ul", _hoisted_4, [
                _createElementVNode("li", _hoisted_5, [
                  _hoisted_6,
                  _createCommentVNode(" START AT "),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('form.start_at.label')), 1 /* TEXT */),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.range.start) = $event)),
                      type: "date",
                      class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': !_ctx.range.start || _ctx.errors?.start_at }]]),
                      required: "",
                      min: _ctx.YYYYMMDD(_ctx._range.start.toDate())
                    }, null, 10 /* CLASS, PROPS */, _hoisted_9), [
                      [_vModelText, _ctx.range.start]
                    ])
                  ]),
                  _createCommentVNode(" ERRORS "),
                  (_ctx.errors?.start_at ?? false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.start_at, (error) => {
                          return (_openBlock(), _createElementBlock("p", {
                            key: error,
                            class: "small text-danger lh-1 m-0 mt-1"
                          }, _toDisplayString(error), 1 /* TEXT */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createCommentVNode(" DATE RANGE "),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("ul", _hoisted_13, [
                _createElementVNode("li", {
                  class: _normalizeClass(["position-relative fw-medium text-dark-emphasis pt-10 pb-20 pe-0 ps-50", [_ctx.showError ? 'danger-step' : 'success-step']])
                }, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["ph-duotone", [_ctx.showError ? 'ph-warning-circle' : 'ph-check-circle']])
                    }, null, 2 /* CLASS */)
                  ]),
                  _createCommentVNode(" START AT "),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('form.end_at.label')), 1 /* TEXT */),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.range.end) = $event)),
                      type: "date",
                      class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.showError || _ctx.errors?.stop_at }]]),
                      required: "",
                      min: _ctx.YYYYMMDD(_ctx._range.start.toDate())
                    }, null, 10 /* CLASS, PROPS */, _hoisted_17), [
                      [_vModelText, _ctx.range.end]
                    ]),
                    _createCommentVNode(" ERRORS "),
                    (_ctx.showError)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t('form.end_at.$error.therapy_range_error', { min: _ctx._range.min })), 1 /* TEXT */)
                        ]))
                      : _createCommentVNode("v-if", true),
                    (_ctx.errors?.stop_at ?? false)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.stop_at, (error) => {
                            return (_openBlock(), _createElementBlock("p", {
                              key: error,
                              class: "small text-danger lh-1 m-0 mt-1"
                            }, _toDisplayString(error), 1 /* TEXT */))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      : _createCommentVNode("v-if", true)
                  ])
                ], 2 /* CLASS */)
              ])
            ])
          ])
        ]),
        (_ctx.therapy_schemes && _ctx.therapy_schemes?.length > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('feature.therapy.drug')), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _withDirectives(_createElementVNode("select", {
                        class: "form-select shadow-none text-black fs-md-15 pe-50",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selected_scheme_id) = $event))
                      }, [
                        _createCommentVNode(" OPTION WITHOUT CLASS NAME "),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scheme_groups, (therapy_schemes, group_name) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: group_name }, [
                            (group_name === 'undefined')
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(therapy_schemes, (scheme) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: scheme.id,
                                    value: scheme.id
                                  }, [
                                    _createTextVNode(_toDisplayString(scheme.drug) + " ", 1 /* TEXT */),
                                    (_ctx.getSchemeRule(scheme)?.intake_per_day !== undefined)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createTextVNode(" - " + _toDisplayString(_ctx.$tc('feature.therapy.intakes_per_day',
                                                        _ctx.getSchemeRule(scheme)!.intake_per_day)) + _toDisplayString(_ctx.getSchemeDose(scheme)), 1 /* TEXT */)
                                        ], 64 /* STABLE_FRAGMENT */))
                                      : _createCommentVNode("v-if", true)
                                  ], 8 /* PROPS */, _hoisted_27))
                                }), 128 /* KEYED_FRAGMENT */))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createCommentVNode(" OPTION GROUPS WITH CLASS NAME "),
                                  _createElementVNode("optgroup", {
                                    label: `${group_name}`
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(therapy_schemes, (scheme) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: scheme.id,
                                        value: scheme.id
                                      }, [
                                        _createTextVNode(_toDisplayString(scheme.drug) + " ", 1 /* TEXT */),
                                        (_ctx.getSchemeRule(scheme)?.intake_per_day !== undefined)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createTextVNode(" - " + _toDisplayString(_ctx.$tc('feature.therapy.intakes_per_day',
                                                            _ctx.getSchemeRule(scheme)!.intake_per_day)) + _toDisplayString(_ctx.getSchemeDose(scheme)), 1 /* TEXT */)
                                            ], 64 /* STABLE_FRAGMENT */))
                                          : _createCommentVNode("v-if", true)
                                      ], 8 /* PROPS */, _hoisted_29))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ], 8 /* PROPS */, _hoisted_28)
                                ], 64 /* STABLE_FRAGMENT */))
                          ], 64 /* STABLE_FRAGMENT */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 512 /* NEED_PATCH */), [
                        [_vModelSelect, _ctx.selected_scheme_id]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("button", {
                        class: "default-btn outlined transition fw-medium fs-md-15 fs-lg-16",
                        disabled: !_ctx.selected_scheme_id,
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addScheme && _ctx.addScheme(...args))),
                        type: "button"
                      }, _toDisplayString(_ctx.$t('cta.add')), 9 /* TEXT, PROPS */, _hoisted_31),
                      (_ctx.show_add_PRN)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "default-btn outlined transition fw-medium fs-md-15 fs-lg-16",
                            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addAllPRN && _ctx.addAllPRN(...args)))
                          }, _toDisplayString(_ctx.$t('feature.therapy.add_all_prn')), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true),
        (_ctx.schemes.length != 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _createElementVNode("table", _hoisted_33, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_34, _toDisplayString(_ctx.$t('feature.therapy.drug')), 1 /* TEXT */),
                    _createElementVNode("th", _hoisted_35, _toDisplayString(_ctx.$t('feature.therapy.dose')), 1 /* TEXT */),
                    (_ctx.config.feature.prn_therapies)
                      ? (_openBlock(), _createElementBlock("th", _hoisted_36, _toDisplayString(_ctx.$t('feature.therapy.prn')), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    (_ctx.therapy_schemes?.length !== 1)
                      ? (_openBlock(), _createElementBlock("th", _hoisted_37))
                      : _createCommentVNode("v-if", true)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  _createCommentVNode(" CENTER ROW "),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schemes, (scheme) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: scheme.id
                    }, [
                      _createElementVNode("td", _hoisted_38, [
                        _createTextVNode(_toDisplayString(scheme.drug) + " ", 1 /* TEXT */),
                        (_ctx.getSchemeRule(scheme)?.intake_per_day !== undefined)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" - " + _toDisplayString(_ctx.$tc('feature.therapy.intakes_per_day',
                                        _ctx.getSchemeRule(scheme)!.intake_per_day)), 1 /* TEXT */)
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createElementVNode("td", _hoisted_39, [
                        (_ctx.show_scheme_doses(scheme))
                          ? _withDirectives((_openBlock(), _createElementBlock("select", {
                              key: 0,
                              class: "form-select shadow-none text-black fs-md-15 w-auto",
                              "onUpdate:modelValue": ($event: any) => ((scheme.default_dose) = $event),
                              required: ""
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scheme.doses, (dose) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: dose,
                                  value: dose
                                }, _toDisplayString(dose), 9 /* TEXT, PROPS */, _hoisted_41))
                              }), 128 /* KEYED_FRAGMENT */))
                            ], 8 /* PROPS */, _hoisted_40)), [
                              [_vModelSelect, scheme.default_dose]
                            ])
                          : (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(scheme.default_dose), 1 /* TEXT */))
                      ]),
                      (_ctx.config.feature.prn_therapies)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_43, [
                            _createElementVNode("div", _hoisted_44, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input shadow-none",
                                type: "checkbox",
                                role: "switch",
                                disabled: "",
                                "onUpdate:modelValue": ($event: any) => ((scheme.is_prn) = $event)
                              }, null, 8 /* PROPS */, _hoisted_45), [
                                [_vModelCheckbox, scheme.is_prn]
                              ])
                            ])
                          ]))
                        : _createCommentVNode("v-if", true),
                      (_ctx.therapy_schemes?.length !== 1)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_46, [
                            _createElementVNode("button", {
                              class: "btn-close",
                              type: "button",
                              onClick: ($event: any) => (_ctx.removeScheme(scheme))
                            }, [..._hoisted_49], 8 /* PROPS */, _hoisted_47)
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" ACTION "),
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("button", {
            class: "default-btn outlined transition fw-medium fs-md-15 fs-lg-16",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.discard && _ctx.discard(...args))),
            type: "button"
          }, _toDisplayString(_ctx.$t('cta.discard')), 1 /* TEXT */),
          _createElementVNode("button", {
            type: "submit",
            class: "default-btn transition fw-medium fs-md-15 fs-lg-16",
            disabled: _ctx.showError || _ctx.schemes.length == 0
          }, _toDisplayString(_ctx.$t('cta.schedule_therapy')), 9 /* TEXT, PROPS */, _hoisted_51)
        ])
      ], 32 /* NEED_HYDRATION */))
}